import { render, staticRenderFns } from "./locale-currency-modal.vue?vue&type=template&id=4f9e84d2&"
import script from "./locale-currency-modal.vue?vue&type=script&lang=js&"
export * from "./locale-currency-modal.vue?vue&type=script&lang=js&"
import style0 from "./locale-currency-modal.vue?vue&type=style&index=0&id=4f9e84d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports